import React, {useEffect} from 'react';
import {connect} from 'react-redux';

import {isEmpty} from 'lodash';

import SystemsTable from './SystemsTable';

import ActionBar from '../../components/ActionBar';
import { TabContent } from '../../components/TabPanel';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableAndSearch.module.css';

const SystemsTableAndSearch = ({
    fetchSystemsByEquipmentId,
    handleSort,
    isFullArchitectAllowed,
    onToggleDeleteSystemEntityModal,
    order,
    orderBy,
    selectedNode,
    systems,
    ...props
}) => {

    useEffect(() => {
        fetchSystemsByEquipmentId(selectedNode);
    }, []);

    const handleSearch = searchFilter => {
        if (isEmpty(searchFilter)) {
            fetchSystemsByEquipmentId(selectedNode);
        } else {
            fetchSystemsByEquipmentId(selectedNode, {searchFilter});
        }
    };

    return (
        <TabContent
            classes={{
                root: classes.tabContent
            }}
        >
            <ActionBar
                onSearch={handleSearch}
            />
            <div className={classes.scrollContainer}>
                <SystemsTable
                    systems={systems}
                    order={order}
                    orderBy={orderBy}
                    onSort={property => handleSort(props, property)}
                    onToggleDeleteSystemEntityModal={onToggleDeleteSystemEntityModal}
                    isFullArchitectAllowed={isFullArchitectAllowed}
                    filterBy="equipment"
                    showContextMenu={true}
                />
            </div>
        </TabContent>
    );
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(null, mapDispatchToProps)(SystemsTableAndSearch);
